import VisitsV1, { NotAllowedKeysForSearch } from './v1';
import { get as versionSelector } from '../../../utils/versionSelector';

const version = new Map([
  [1, VisitsV1],
]);

export const get = versionSelector.bind(this, version);

export {
  NotAllowedKeysForSearch
};

export default VisitsV1;
